import React, { useEffect } from "react";
import "../styles/home.css";
import "../styles/hotels.css";
import "../styles/school.css";
import "../styles/default.css";
import Footer from "./common/Footer.jsx";
import Navbar from "./common/Navbar.jsx";

const OtherServicesPage = () => {
  useEffect(() => {
    // Scroll event listener
    const handleScroll = () => {
      const elements = document.querySelectorAll(".toshow");

      elements.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const showPoint = 5;

        if (elementTop < windowHeight - showPoint) {
          element.classList.add("toshowactive");
        } else {
          element.classList.remove("toshowactive");
        }
      });
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="homeMainContainer">
        <div className="secondMainNav ibloSchoolTitl revonMob">
          <div className="rightCont">
            <div className="theTitle title">OTHER SERVICES</div>
            <p>
              We are thrilled to have you here. <br />
              Our website is dedicated to providing top-quality online services
              that are designed to make your life easier.
            </p>
            <p>
              Whether you are looking for development of mobile applications and
              website design or simply get work done, we have got you covered.
              Our user-friendly platform is easy to navigate and offers a wide
              range of services that are tailored to meet your needs.
            </p>
            <div className="btn2 riCon">Join Now</div>
          </div>
          <div className="leftCont">
            <img src="../images/other_services.png" alt="Other Services" />
          </div>
        </div>

        <div className="whatsIblotec">
          <div className="title whuse">Why use these services?</div>
          <p>
            Customer service: Our team of experts is always available to answer
            your questions and help you with anything you need. We believe that
            everyone deserves access to reliable and efficient online services,
            and that's exactly what we offer.
          </p>
        </div>

        <div className="theDiv">
          <div className="theDivLeft">
            <p>
              So go ahead, explore our website, and see what we have to offer.
              We are confident that you'll find something that's just right for
              you.
            </p>
            <p className="tec">
              Thank you for choosing IBlotec INTERNET AND BLOCKCHAIN TECHNOLOGY.
            </p>
            <p>We look forward to serving you.</p>
          </div>
          <div className="theDivRight">
            <img src="../images/invest2.jpg" alt="Invest" />
          </div>
        </div>

        <div className="pricesTable">
          <div className="priceTitle">OUR PRICING</div>
          <div className="pricesCont">
            <div className="priceblock">
              <div className="priceInfo">
                <span className="coursename">WEBSITES DEVELOPMENT</span>
                <span className="courselegend">
                  We design your website and mobile application in a short
                  period of time starting from
                </span>
                <span className="courseprice">$300.00</span>
              </div>
              <div className="btn1 joinbtnprice">ORDER YOURS</div>
            </div>
            <div className="priceblock">
              <div className="priceInfo">
                <span className="coursename">DESIGN</span>
                <span className="courselegend">
                  We design any design you want in a short period of time
                  starting from
                </span>
                <span className="courseprice">$7.00</span>
              </div>
              <div className="btn1 joinbtnprice">ORDER YOURS</div>
            </div>
            <div className="priceblock">
              <div className="priceInfo">
                <span className="coursename">COACHING</span>
                <span className="courselegend">
                  We create any explanatory video for advertising your products
                  and services in a short period of time starting from
                </span>
                <span className="courseprice">$50.00</span>
              </div>
              <div className="btn1 joinbtnprice">ORDER YOURS</div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OtherServicesPage;
